<nts-iframe
  [class.in-iframe]="inIframe"
  (loaded)="iframeLoaded.next($event)"
  [url]="url"
  (statusChanged)="onStatusPush($event)">
</nts-iframe>